import {isEmpty} from 'lodash';
import {Params, Router} from '@angular/router';
import {Component, Input} from '@angular/core';
import {Validator} from '../../utils/Validator';
import {HttpClient} from '@angular/common/http';
import {ApiServiceService} from '../../api-service.service';
import {Logger} from '../../utils/Logger';
import {FormGroup} from '@angular/forms';
import { ConfigService } from '../../service/config.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    providers: [ApiServiceService, Validator]
})
export class ContactUsComponent {
    public name: string;
    public email: string;
    public message: string;
    public phoneNumber: string;

    public errorMessage: string;
    public formSubmitted: boolean;
    public shouldShowLoader: boolean;
    isCaptchaResolved = false;
    activeFinzyVersion: string;

    @Input('form-position')
    public formPosition: 'left' | 'right' = 'right';

    constructor(private httpClient: HttpClient, protected router: Router,
                private apiService: ApiServiceService, protected validator: Validator, private configService: ConfigService) {
                    this.activeFinzyVersion = this.configService.getActiveFinzyVersion();
    }

    public async onContactFormSubmit(formGroup: FormGroup, metadata?: Params): Promise<void> {
        const formValue = this.getContactDetails(formGroup);
        this.errorMessage = this.validateFields(formValue.name, formValue.email, formValue.phoneNumber, formValue.message);

        if (this.errorMessage) {
            return;
        }

        await this.submitContactForm(formGroup, metadata);
    }

    public onNameInput(event: any): void {
        this.formSubmitted = false;
        this.name = event.target.value.replace(/[^A-Za-z ]+/, '');
    }

    protected async submitContactForm(formGroup: FormGroup, metadata: Params) {
        try {
            const formValue = this.getContactDetails(formGroup);
            this.showLoader();
            await this.httpClient.post(this.apiService.baseURL() + 'contact-us', {
                name: formValue.name,
                phoneNumber: isEmpty(formValue.phoneNumber) ? undefined : formValue.phoneNumber,
                email: formValue.email,
                message: formValue.message,
                metadata: metadata
            }).toPromise();

            this.onSuccessfulSubmission(formGroup);
        } catch (error) {
            Logger.log(`An error occurred while submitting contact form ${JSON.stringify(error)}`);
            this.onErroneousSubmission();
        } finally {
            this.hideLoader();
        }
    }

    protected validateFields(name: string, email: string, phoneNumber: string, message: string): string {
        const isValidEmailFormat = this.validator.isValidEmailFormat(email);

        if (!name || !email || !isValidEmailFormat) {
            return 'Please provide valid name and email address';
        }

        if (phoneNumber && !this.validator.isMobilePhone(phoneNumber)) {
            return 'Please provide valid phone number';
        }

        if (!message) {
            return 'Please provide a message';
        }
        if (!this.isCaptchaResolved) {
            return 'Please complete the captcha';
        }
    }

    protected onSuccessfulSubmission(formGroup: FormGroup) {
        this.formSubmitted = true;
        this.errorMessage = undefined;
        this.resetForm(formGroup);
    }

    protected onErroneousSubmission() {
        this.errorMessage = 'An error occurred while submitting contact form, please try again later.';
    }

    private resetForm(formGroup: FormGroup): void {
        formGroup.reset();
        Object.keys(formGroup.controls).forEach(controlName => {
            formGroup.controls[controlName].setErrors(null);
        });
    }

    private getContactDetails(formGroup: FormGroup) {
        return {
            name: formGroup.value.name,
            email: formGroup.value.email,
            phoneNumber: formGroup.value.phoneNumber,
            message: formGroup.value.message
        };
    }

    private showLoader() {
        this.shouldShowLoader = true;
    }

    private hideLoader() {
        this.shouldShowLoader = false;
    }

    captchaResolved(response: string) {
        this.isCaptchaResolved = response ? true : false;
        if (this.isCaptchaResolved && this.errorMessage === 'Please complete the captcha') {
            this.errorMessage = undefined;
        }
    }
    captchaError(error: any) {
        this.isCaptchaResolved = false;
    }
}
